import { Directive, effect, inject, input } from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[libTooltip]',
  hostDirectives: [NgbTooltip],
})
export class TooltipDirective {
  private readonly ngbTooltip = inject(NgbTooltip);

  readonly tooltipText = input.required<string | undefined>({ alias: 'libTooltip' });
  readonly toolTipStyle = input<'title' | 'subtitle'>('title');

  private readonly tooltipEffect = effect(() => {
    this.ngbTooltip.ngbTooltip = this.tooltipText();
    this.ngbTooltip.tooltipClass = 'light-tooltip light-tooltip-' + this.toolTipStyle();
  });
}
